var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveDisable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 0H2.5C1.39 0 0.5 0.9 0.5 2V16C0.5 17.1 1.39 18 2.5 18H16.5C17.6 18 18.5 17.1 18.5 16V4L14.5 0ZM16.5 16H2.5V2H13.67L16.5 4.83V16ZM9.5 9C7.84 9 6.5 10.34 6.5 12C6.5 13.66 7.84 15 9.5 15C11.16 15 12.5 13.66 12.5 12C12.5 10.34 11.16 9 9.5 9ZM3.5 3H12.5V7H3.5V3Z",
    fill: "#959da1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDisable);
export default __webpack_public_path__ + "static/media/saveDisable.11cd5c433ff7f029ddb23b3823199953.svg";
export { ForwardRef as ReactComponent };